// extracted by mini-css-extract-plugin
export default {"svgIcon":"icon_svgIcon__o0702","svgIconInner":"icon_svgIconInner__NrHzj","rotate":"icon_rotate__2vYCu"};